export default {
  name: 'jaka',
  defaults: [
    {
      svg: {
        widthsAndHeights: 'path/to/svg oder SVG',
        length: 'path/to/svg oder SVG',
        notches: 'path/to/svg oder SVG'
      }
    },
    {
      profilColor: ''
    },
    {
      a: {
        min: 500,
        max: 99000,
        default: 500
      }
    },
    {
      a1: {
        min: 100,
        max: 100,
        steps: 10,
        default: 100
      }
    },
    {
      a2: {
        min: 100,
        max: 100,
        steps: 10,
        default: 100
      }
    },
    {
      totalLength: 500
    },
    {
      totalLengthOfOneElement: 2400
    },
    {
      b: {
        min: 140,
        max: 300,
        steps: 20,
        default: 180
      }
    },
    {
      h: {
        min: 20,
        max: 20,
        default: 20
      }
    },
    {
      w: {
        min: 20,
        max: 200,
        steps: 5,
        default: 40
      }
    },
    {
      e: {
        min: 100,
        max: 140,
        steps: 20,
        default: 120
      }
    },
    {
      d1: {
        min: 240,
        max: 280,
        steps: 40,
        default: 280
      }
    },
    {
      d2: {
        min: 120,
        max: 160,
        default: 120
      }
    },
    {
      c: {
        min: 400,
        max: 400,
        steps: 1,
        default: 400
      }
    },
    {
      f: {
        min: 0,
        max: 150,
        default: 0
      }
    },
    {
      g: {
        min: 0,
        max: 200,
        default: 0
      }
    },
    {
      dripEdgeProfile: 0
    },
    {
      wallProfiles: ''
    },
    {
      vacuumPanels: ''
    },
    {
      vipWidth: 0
    }
  ],

  /*
  * getters
  */

  get: function (value) {
    for (var i = 0; i < this.defaults.length; i++) {
      var obj = this.defaults[i]
      for (var key in obj) {
        if (key === value) {
          return obj[key]
        }
      }
    }
  },

  /*
  * set depedencies for values
  */

  // if Vakuumpanel is added Change values
  hasVIP: function () {
    const changedValues = {
      w: {
        min: 0,
        max: 0,
        default: 0,
        vipWidth: 0
      },
      b: {
        min: 0,
        max: 0,
        default: 0
      },
      c: {
        min: 0,
        max: 0,
        default: 0
      },
      d1: {
        min: 0,
        max: 0,
        default: 0
      }
    }
    return changedValues
  },

  validateData: function (currentOrder) {
  },
  getErrors: function (currentOrder) {
    let errors = {}
    for (var i = 0; i < this.defaults.length; i++) {
      var obj = this.defaults[i]
      for (var key in obj) {
        var keyData = obj[key]
        var valueOfOrder = currentOrder[key]
        if (this.checkMin(key, keyData, valueOfOrder, currentOrder)) {
          errors[key] = ('min')
        }
        if (this.checkMax(key, keyData, valueOfOrder, currentOrder)) {
          errors[key] = ('max')
        }
        if (this.checkSteps(key, keyData, valueOfOrder)) {
          errors[key] = ('steps')
        }

        if (key === 'c' || key === 'd1') {
          if (currentOrder.c <= currentOrder.d1) {
            errors[key] = ('d1BiggerThenC')
          }
        }

        if (key === 'b') {
          if (currentOrder.e + currentOrder.h + currentOrder.w !== currentOrder.b) {
            errors[key] = ('bIsNotCorrect')
          }
        }

        if (key === 'g') {
          if (currentOrder.w < currentOrder.g) {
            errors[key] = ('gIsgraterThanW')
          }
        }
      }
    }
    return errors
  },
  getMins: function (currentOrder) {
    let minArray = []
    for (var i = 0; i < this.defaults.length; i++) {
      var obj = this.defaults[i]
      for (var key in obj) {
        if (key === 'w' && currentOrder.vacuumPanels === 'vip') {
          minArray[key] = this.hasVIP()['w'].min
        } else if (key === 'b' && currentOrder.vacuumPanels === 'vip') {
          minArray[key] = this.hasVIP()['b'].min
        } else if (key === 'c' && currentOrder.vacuumPanels === 'vip') {
          minArray[key] = this.hasVIP()['c'].min
        } else if (key === 'd1' && currentOrder.vacuumPanels === 'vip') {
          minArray[key] = this.hasVIP()['d1'].min
        } else {
          minArray[key] = obj[key].min
        }
      }
    }
    return minArray
  },
  checkMin: function (key, keyData, valueOfOrder, currentOrder) {
    let minError = false
    if (keyData.min) {
      if (key === 'w' && this.hasVIP()['w'].min > valueOfOrder && currentOrder.vacuumPanels === 'vip') {
        minError = true
      } else if (key === 'b' && this.hasVIP()['b'].min > valueOfOrder && currentOrder.vacuumPanels === 'vip') {
        minError = true
      } else if (key === 'c' && this.hasVIP()['c'].min > valueOfOrder && currentOrder.vacuumPanels === 'vip') {
        minError = true
      } else if (key === 'd1' && this.hasVIP()['d1'].min > valueOfOrder && currentOrder.vacuumPanels === 'vip') {
        minError = true
      } else if (keyData.min > valueOfOrder) {
        minError = true
      }
    }
    return minError
  },

  checkMax: function (key, keyData, valueOfOrder) {
    let maxError = false
    if (keyData.max) {
      if (keyData.max < valueOfOrder) {
        maxError = true
      }
    }
    return maxError
  },

  checkSteps: function (key, keyData, valueOfOrder) {
    let stepsError = false
    if (keyData.steps) {
      if (valueOfOrder % keyData.steps) {
        stepsError = true
      }
    }
    return stepsError
  },

  getWarnings: function (currentOrder) {
    // console.log('jakp getWarnings')
    let currentWarnings = {}

    // elementLengths related warnings
    let elementLengths = {}
    elementLengths['totalLengthOfOneElement'] = (currentOrder.totalElements > 1)
    elementLengths['totalElements'] = (currentOrder.totalElements > 1)
    currentWarnings['elementLengths'] = elementLengths

    // elementHeights related warnings
    let elementHeights = {}
    elementHeights['specialConfigD2'] = (currentOrder.d2 < 120) ? 120 : false
    currentWarnings['elementHeights'] = elementHeights

    // elementWidths related warnings
    let elementWidths = {}
    elementWidths['eIsLowerThanEquals115'] = (currentOrder.e <= 115)
    elementWidths['elementWidthcalculationWarning'] = (currentOrder.e + currentOrder.h + currentOrder.w !== currentOrder.b)
    currentWarnings['elementWidths'] = elementWidths

    // vacuumPanels related warnings
    let vacuumPanels = {}
    currentWarnings['vacuumPanels'] = vacuumPanels

    // endProfiles related warnings
    let endProfiles = {}
    currentWarnings['endProfiles'] = endProfiles

    return currentWarnings
  },

  // Helper functions

  log: function () {
    // console.log(this)
  }
}
